import { ViewportScroller } from '@angular/common';
import { AfterContentInit, ChangeDetectorRef, Component, ComponentFactory, ComponentFactoryResolver, ComponentRef, EventEmitter, Input, Output, ViewChild, ViewContainerRef, ViewRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ArticleDetailComponent } from '../article-detail/article-detail.component';
import { ArticleSearchComponent } from '../article-search/article-search.component';

@Component({
	selector: 'app-article',
	templateUrl: './article.component.html',
	styleUrls: ['./article.component.scss'],
})
export class ArticleComponent implements AfterContentInit {

	@Input() set embedded(p_embedded: boolean) {
		this.m_embedded = p_embedded;
	}

	@Input() set onlyOrderableArticles(p_onlyOrderableArticles: boolean) {
		this.m_onlyOrderableArticles = p_onlyOrderableArticles;
	}

	@Input() set forCompany(p_forCompany: boolean) {
		this.m_forCompany = p_forCompany;
	}

	get forCompany(): boolean {
		return this.m_forCompany;
	}

	@Output() public articleSelect: EventEmitter<string> = new EventEmitter();

	@ViewChild('articleRef', { read: ViewContainerRef, static: true }) public m_articleContainerRef: ViewContainerRef;

	public m_articleSearchViewRef: ViewRef;
	public m_componentRefArticleSearch: ComponentRef<ArticleSearchComponent>;
	public m_componentRefArticleDetails: ComponentRef<ArticleDetailComponent>;

	private m_forCompany: boolean = false;
	public m_selectedTab: number = 0;
	public m_articleOid: string;
	public m_embedded: boolean = false;
	public m_onlyOrderableArticles: boolean = true;

	constructor(
		private m_comFactoryResolver: ComponentFactoryResolver,
		private viewPort: ViewportScroller,
		private changeDetector: ChangeDetectorRef,
		private m_router: Router,
		private m_route: ActivatedRoute,
	) { }


	/**
	 * Methode zum Anzeigen der Artikelsuche wird aufgerufen.
	 */
	public ngAfterContentInit(): void {
		this.showArticleSearch();
	}

	/**
	 * Es wird eine Factory zum dynamischen laden von Components erstellt. In dieser Factory wird per default die Component
	 * der Artikelsuche geladen. Bei Bedarf wird die Methode für das laden der Artikeldetails geladen.
	 */
	public showArticleSearch(): void {
		if (this.m_articleContainerRef != null) {
			this.m_articleContainerRef.clear();
		}
		if (this.m_articleSearchViewRef != null) {
			this.m_articleContainerRef.insert(this.m_articleSearchViewRef);
			this.m_componentRefArticleSearch.instance.loadLastSearchValues();
		} else {
			const myFactory: ComponentFactory<ArticleSearchComponent> = this.m_comFactoryResolver.resolveComponentFactory(ArticleSearchComponent);
			this.m_componentRefArticleSearch = this.m_articleContainerRef.createComponent(myFactory);
			this.m_componentRefArticleSearch.instance.showSelectButton = this.m_embedded; // select
			this.m_componentRefArticleSearch.instance.onlyOrderableArticles = this.m_onlyOrderableArticles;
			this.m_componentRefArticleSearch.instance.forCompany = this.m_forCompany;
			this.m_componentRefArticleSearch.instance.openDetails.subscribe((next) => {
				this.m_articleSearchViewRef = this.m_articleContainerRef.detach();
				if (this.m_embedded) {
					this.showArticleDetails(next);
				} else {
					this.m_router.onSameUrlNavigation = 'reload';
					this.m_router.navigate(['./'], { relativeTo: this.m_route, fragment: next, skipLocationChange: false }).then(() => {
						this.m_router.navigate(['/artikel', 'details', next], { fragment: next });
					});
				}
			});
			this.m_componentRefArticleSearch.instance.articleSelect.subscribe((next) => {
				this.selectArticle(next);
			});
		}
	}

	/**
	 * Die Component der Artikeldetails wird in die Factory zum dynamischen laden von Components geladen. Die Artikel OID wird übergeben.
	 * @param p_articleOid OID des ausgewählten Artikels
	 */
	public showArticleDetails(p_articleOid: string): void {
		const myFactory: ComponentFactory<ArticleDetailComponent> = this.m_comFactoryResolver.resolveComponentFactory(ArticleDetailComponent);
		this.m_componentRefArticleDetails = this.m_articleContainerRef.createComponent(myFactory);
		this.m_componentRefArticleDetails.instance.articleOid = p_articleOid;
		this.m_componentRefArticleDetails.instance.isEmbedded = this.m_embedded;
		this.m_componentRefArticleDetails.instance.onlyOrderableArticles = this.m_onlyOrderableArticles;
		this.m_componentRefArticleDetails.instance.exit.subscribe(() => {
			this.showArticleSearch();
		});
		this.m_componentRefArticleDetails.instance.articleSelect.subscribe((next) => {
			this.selectArticle(next);
		});
		this.viewPort.scrollToPosition([0, 0]);
		this.changeDetector.detectChanges();
	}

	/**
	 * Artikel der Artikelsuche wird an aufrufendes Component übergeben.
	 * @param p_articleOid ArticleSearch Artikel
	 */
	public selectArticle(p_articleOid: string): void {
		this.articleSelect.emit(p_articleOid);
	}

}
